import type { ThemeConfig } from 'antd';

/** Shared with Chart cards (`border-slate-200`). */
export const CARD_BORDER_COLOR = '#b7bdb9';
export const CARD_BORDER_COLOR_DARK = '#b7bdb9';

export const antdTheme: ThemeConfig = {
  token: {
    colorPrimary: '#009966',
    colorPrimaryHover: '#009966',
    colorPrimaryActive: '#009966',
    colorBorderSecondary: CARD_BORDER_COLOR,
  },
  components: {
    Card: {
      colorBorderSecondary: CARD_BORDER_COLOR,
    },
    Select: {
      optionSelectedBg: '#00D492',
      optionSelectedColor: '#ffffff',
      optionSelectedFontWeight: 500,
    },
    Table: {
      headerSplitColor: 'transparent',
      headerBg: '#fafafa',
      headerColor: '#0a0a0a',
      borderColor: '#f0f0f0',
    },
  },
};
